export interface MovieItem {
  id: string;
  title: string;
  category: 'dianshiju' | 'dianying' | 'zongyi';
  subcategory: string;
  year: number;
  rating: number;
  imageUrl: string;
  description: string;
  director: string;
  cast: string[];
  region: string;
  episodes?: number;
  duration?: string;
  isHot: boolean;
  isNew: boolean;
  updateInfo?: string;
  content: string;
}

export const allContent: MovieItem[] = [
  {
    id: 'dianshiju-1',
    title: '长安十二时辰',
    category: 'dianshiju',
    subcategory: '古装剧',
    year: 2019,
    rating: 8.2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20drama%20film%20poster%20style%20with%20warriors%20and%20ancient%20city%20at%20night%20cinematic%20dramatic%20lighting%20rich%20warm%20colors%20professional%20movie%20poster%20design%20dark%20moody%20atmosphere&width=400&height=225&seq=tv-changan-card&orientation=landscape',
    description: '唐朝天宝三年，上元节前夕，长安城陷入危机。死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安。',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    region: '中国大陆',
    episodes: 48,
    isHot: true,
    isNew: false,
    updateInfo: '已完结',
    content: '《长安十二时辰》改编自马伯庸同名小说，讲述了唐朝天宝三年上元节前夕，长安城混入可疑人员，身陷囹圄的张小敬临危受命，与少年天才李必携手在十二时辰内破除隐患的故事。该剧以精良的制作、考究的服化道和紧凑的剧情赢得了观众的一致好评，被誉为国产古装剧的巅峰之作。剧中不仅展现了盛唐时期的繁华景象，更深入刻画了人物命运的起伏与人性的复杂。',
  },
  {
    id: 'dianshiju-2',
    title: '狂飙',
    category: 'dianshiju',
    subcategory: '涉案剧',
    year: 2023,
    rating: 8.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20film%20poster%20style%20police%20and%20gangster%20dark%20urban%20night%20scene%20cinematic%20lighting%20intense%20atmosphere%20professional%20movie%20poster%20design%20gritty%20realistic&width=400&height=225&seq=tv-kuangbiao-card&orientation=landscape',
    description: '一部横跨二十年的扫黑除恶斗争史诗，讲述了刑警安欣与黑恶势力二十余年的正邪较量。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    region: '中国大陆',
    episodes: 39,
    isHot: true,
    isNew: false,
    updateInfo: '已完结',
    content: '《狂飙》以一线刑警安欣的视角，讲述了京海市盘踞多年的黑恶势力及其保护伞被逐步铲除的惊心动魄过程。剧中张颂文饰演的高启强从一个普通鱼贩蜕变为黑恶势力头目的过程令人震撼，张译饰演的安欣二十年如一日坚守正义的精神令人动容。该剧播出后引发全民追剧热潮，成为现象级国产剧。',
  },
  {
    id: 'dianshiju-3',
    title: '繁花',
    category: 'dianshiju',
    subcategory: '都市剧',
    year: 2024,
    rating: 8.7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Shanghai%201990s%20nostalgic%20drama%20film%20poster%20style%20elegant%20city%20night%20neon%20lights%20retro%20aesthetic%20cinematic%20warm%20golden%20lighting%20professional%20movie%20poster%20design&width=400&height=225&seq=tv-fanhua-card&orientation=landscape',
    description: '九十年代的上海，人人争上游。阿宝变成宝总，在沪上弄潮中经历人生起伏与情感纠葛。',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    region: '中国大陆',
    episodes: 30,
    isHot: true,
    isNew: true,
    updateInfo: '已完结',
    content: '《繁花》是导演王家卫的首部电视剧作品，改编自金宇澄同名小说。该剧以九十年代的上海为背景，讲述了阿宝从平凡青年成长为商界传奇"宝总"的故事。剧中浓郁的上海风情、精致的画面美学、以及王家卫标志性的叙事风格，使其成为2024年最具话题性的电视剧之一。胡歌的精彩演绎让宝总这个角色深入人心。',
  },
  {
    id: 'dianshiju-4',
    title: '三体',
    category: 'dianshiju',
    subcategory: '科幻剧',
    year: 2023,
    rating: 8.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20film%20poster%20style%20space%20cosmic%20mysterious%20dark%20universe%20stars%20cinematic%20futuristic%20atmosphere%20professional%20movie%20poster%20design%20cool%20blue%20tones&width=400&height=225&seq=tv-santi-card&orientation=landscape',
    description: '纳米科学家汪淼与刑警史强共同揭开地外文明"三体"世界的神秘面纱。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    region: '中国大陆',
    episodes: 30,
    isHot: false,
    isNew: false,
    updateInfo: '已完结',
    content: '《三体》改编自刘慈欣同名科幻巨著，讲述了地球基础科学研究遭遇异常扰动，纳米科学家汪淼与刑警史强联手调查，逐步揭开地外文明"三体"世界神秘面纱的故事。该剧在视觉效果和科学设定上力求还原原著精髓，为中国科幻电视剧树立了新标杆。',
  },
  {
    id: 'dianshiju-5',
    title: '庆余年第二季',
    category: 'dianshiju',
    subcategory: '古装剧',
    year: 2024,
    rating: 8.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20film%20poster%20style%20ancient%20palace%20intrigue%20handsome%20hero%20cinematic%20epic%20lighting%20rich%20imperial%20colors%20professional%20movie%20poster%20design&width=400&height=225&seq=tv-qingyunian2-card&orientation=landscape',
    description: '范闲假死归来，继续在庆国朝堂上运筹帷幄，与各方势力展开更激烈的博弈。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    region: '中国大陆',
    episodes: 36,
    isHot: true,
    isNew: true,
    updateInfo: '已完结',
    content: '《庆余年第二季》延续第一季的故事线，范闲假死脱身后重返京都，在更加复杂的朝堂局势中周旋。新一季在保持原有幽默风格的基础上，加深了权谋斗争的层次，同时也揭开了更多关于范闲身世的秘密。张若昀的演技更加成熟，老戏骨陈道明、吴刚的加盟让整部剧的质感再上一层。',
  },
  {
    id: 'dianshiju-6',
    title: '漫长的季节',
    category: 'dianshiju',
    subcategory: '悬疑剧',
    year: 2023,
    rating: 9.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Northeast%20China%20suspense%20drama%20film%20poster%20style%20rust%20belt%20industrial%20town%20autumn%20melancholy%20cinematic%20moody%20lighting%20nostalgic%20atmosphere%20professional%20movie%20poster%20design&width=400&height=225&seq=tv-changman-card&orientation=landscape',
    description: '一座横跨近二十年的北方小城，一桩悬而未决的碎尸案，三个老伙计的人生交织。',
    director: '辛爽',
    cast: ['范伟', '秦昊', '陈明昊', '李庚希'],
    region: '中国大陆',
    episodes: 12,
    isHot: false,
    isNew: false,
    updateInfo: '已完结',
    content: '《漫长的季节》以三条时间线交织的叙事方式，讲述了一桩发生在东北小城的碎尸案如何影响了几个家庭近二十年的命运。范伟贡献了演艺生涯中最具突破性的表演，将一个普通出租车司机内心的执念与痛苦刻画得入木三分。该剧豆瓣评分高达9.4，被誉为近年最好的国产悬疑剧。',
  },
  {
    id: 'dianying-1',
    title: '流浪地球2',
    category: 'dianying',
    subcategory: '科幻',
    year: 2023,
    rating: 8.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20blockbuster%20film%20poster%20style%20spaceship%20earth%20engines%20space%20epic%20cinematic%20futuristic%20dramatic%20lighting%20professional%20movie%20poster%20design&width=400&height=225&seq=mv-liulang2-card&orientation=landscape',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启长达2500年的流浪之旅。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢'],
    region: '中国大陆',
    duration: '173分钟',
    isHot: true,
    isNew: false,
    content: '《流浪地球2》是《流浪地球》的前传，讲述了"太阳危机"即将来袭，人类面临末日灾难与生命存续的双重挑战。影片在视觉效果上实现了国产科幻电影的新突破，太空电梯、月球发动机等场景令人叹为观止。刘德华饰演的图恒宇线更是为影片增添了深度的人文思考。',
  },
  {
    id: 'dianying-2',
    title: '满江红',
    category: 'dianying',
    subcategory: '悬疑',
    year: 2023,
    rating: 7.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20film%20poster%20style%20Song%20dynasty%20ancient%20courtyard%20red%20lanterns%20dark%20mysterious%20cinematic%20lighting%20professional%20movie%20poster%20design&width=400&height=225&seq=mv-manjianghong-card&orientation=landscape',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩凶案牵扯出惊天阴谋。',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    region: '中国大陆',
    duration: '159分钟',
    isHot: false,
    isNew: false,
    content: '《满江红》是张艺谋执导的悬疑喜剧电影，以南宋为背景，通过一桩离奇的凶杀案展开了一场扣人心弦的迷局。影片在有限的场景内通过不断反转的剧情保持了高度紧张感，结尾处全军复诵《满江红》的场面更是令人热血沸腾。沈腾和易烊千玺的搭档产生了令人惊喜的化学反应。',
  },
  {
    id: 'dianying-3',
    title: '热辣滚烫',
    category: 'dianying',
    subcategory: '喜剧',
    year: 2024,
    rating: 7.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20film%20poster%20style%20boxing%20ring%20inspirational%20warm%20lighting%20energetic%20atmosphere%20professional%20movie%20poster%20design%20bright%20vibrant%20colors&width=400&height=225&seq=mv-relaguntang-card&orientation=landscape',
    description: '乐莹是一个善良但一直宅在家中的女孩，在经历一系列打击后，她决定改变自己的人生。',
    director: '贾玲',
    cast: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    region: '中国大陆',
    duration: '129分钟',
    isHot: true,
    isNew: true,
    content: '《热辣滚烫》讲述了一个关于自我救赎与成长的故事。乐莹在经历感情和事业的双重打击后，通过拳击这项运动重新找到了人生的方向与力量。贾玲为这部电影减重100斤的敬业精神令人敬佩，影片传递的"爱自己"主题引发了广泛共鸣，成为2024年春节档票房冠军。',
  },
  {
    id: 'dianying-4',
    title: '孤注一掷',
    category: 'dianying',
    subcategory: '犯罪',
    year: 2023,
    rating: 7.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20film%20poster%20style%20dark%20underground%20scam%20factory%20Southeast%20Asia%20intense%20cinematic%20lighting%20gritty%20realistic%20professional%20movie%20poster%20design&width=400&height=225&seq=mv-guzhuyizhi-card&orientation=landscape',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。',
    director: '申奥',
    cast: ['张艺兴', '金晨', '王传君', '王大陆'],
    region: '中国大陆',
    duration: '130分钟',
    isHot: false,
    isNew: false,
    content: '《孤注一掷》聚焦于网络诈骗这一社会热点话题，通过真实细腻的叙事展现了境外诈骗工厂的运作内幕和受害者的悲惨遭遇。王传君饰演的诈骗头目令人不寒而栗，影片的教育意义和社会价值得到了观众的广泛认可。',
  },
  {
    id: 'dianying-5',
    title: '封神第一部',
    category: 'dianying',
    subcategory: '奇幻',
    year: 2023,
    rating: 7.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20film%20poster%20style%20ancient%20mythology%20gods%20warriors%20battle%20cinematic%20grand%20dramatic%20lighting%20professional%20movie%20poster%20design&width=400&height=225&seq=mv-fengshen1-card&orientation=landscape',
    description: '殷商末年，纣王暴虐无道。姬发觉醒，踏上封神之路。一场人、神、妖三界的史诗大战即将展开。',
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适'],
    region: '中国大陆',
    duration: '148分钟',
    isHot: false,
    isNew: false,
    content: '《封神第一部：朝歌风云》是乌尔善执导的奇幻史诗大片三部曲的开篇之作。影片以宏大的场面、精致的特效和扎实的演技重新诠释了中国神话经典。费翔饰演的纣王气场全开，新生代演员于适的表现也令人惊喜。',
  },
  {
    id: 'dianying-6',
    title: '第二十条',
    category: 'dianying',
    subcategory: '剧情',
    year: 2024,
    rating: 7.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20film%20poster%20style%20courtroom%20justice%20solemn%20atmosphere%20cinematic%20balanced%20lighting%20professional%20movie%20poster%20design%20realistic%20tone&width=400&height=225&seq=mv-diershitiao-card&orientation=landscape',
    description: '关于《刑法》第二十条"正当防卫"条款的现实主义题材电影，探讨法理与人情的边界。',
    director: '张艺谋',
    cast: ['雷佳音', '马丽', '赵丽颖', '高叶'],
    region: '中国大陆',
    duration: '141分钟',
    isHot: true,
    isNew: true,
    content: '《第二十条》以《刑法》第二十条"正当防卫"条款为切入点，通过三个相互关联的案件探讨了法律与人情的边界。影片在保持现实主义基调的同时融入了张艺谋导演独特的黑色幽默，雷佳音和马丽的表演默契十足，赵丽颖的聋哑人角色演绎更是令人惊艳。',
  },
  {
    id: 'zongyi-1',
    title: '奔跑吧·生态篇',
    category: 'zongyi',
    subcategory: '户外真人秀',
    year: 2024,
    rating: 7.2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20outdoor%20running%20game%20nature%20landscape%20poster%20style%20bright%20sunny%20energetic%20cinematic%20fun%20atmosphere%20professional%20show%20poster%20design&width=400&height=225&seq=zy-benpaoba-card&orientation=landscape',
    description: '奔跑家族再次集结，以生态环保为主题，在各地的自然风光中展开趣味挑战。',
    director: '姚译添',
    cast: ['李晨', '郑恺', '沙溢', '白鹿', '周深', '范丞丞'],
    region: '中国大陆',
    episodes: 12,
    isHot: true,
    isNew: true,
    updateInfo: '更新至第8期',
    content: '《奔跑吧·生态篇》是国民综艺《奔跑吧》的最新一季，以生态环保为核心主题。本季跑男家族走进全国各地的自然保护区，通过趣味游戏和挑战任务向观众传递环保理念。新老成员的精彩互动和各地壮美的自然风光是本季最大的看点。',
  },
  {
    id: 'zongyi-2',
    title: '歌手2024',
    category: 'zongyi',
    subcategory: '音乐竞演',
    year: 2024,
    rating: 7.6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20singing%20competition%20show%20poster%20style%20stage%20spotlight%20music%20concert%20dramatic%20cinematic%20lighting%20elegant%20professional%20show%20poster%20design%20grand%20atmosphere&width=400&height=225&seq=zy-geshou2024-card&orientation=landscape',
    description: '殿堂级音乐竞演节目重磅回归，国内外顶级歌手同台献唱，用音乐点燃整个夏天。',
    director: '洪啸',
    cast: ['那英', '汪苏泷', 'Faouzia', 'Chante Moore'],
    region: '中国大陆',
    episodes: 13,
    isHot: true,
    isNew: true,
    updateInfo: '更新至第10期',
    content: '《歌手2024》时隔多年重磅回归，赛制全面升级。本季首次采用全程直播形式，让观众零时差感受顶级歌手的真实唱功。国际歌手的加入提升了竞演水准和观赏性，中外音乐的碰撞产生了令人惊喜的火花。每一期都堪比一场视听盛宴。',
  },
  {
    id: 'zongyi-3',
    title: '种地吧第二季',
    category: 'zongyi',
    subcategory: '纪实真人秀',
    year: 2024,
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20farming%20reality%20show%20poster%20style%20rural%20farmland%20green%20fields%20young%20people%20working%20natural%20sunlight%20warm%20cinematic%20authentic%20atmosphere%20professional%20show%20poster&width=400&height=225&seq=zy-zhongdiba2-card&orientation=landscape',
    description: '十个少年继续农耕生活，用双手耕耘土地，收获成长与友谊的真实记录。',
    director: '杨长亮',
    cast: ['蒋敦豪', '鹭卓', '李耕耘', '李昊', '赵一博', '卓沅'],
    region: '中国大陆',
    episodes: 40,
    isHot: false,
    isNew: true,
    updateInfo: '更新至第30期',
    content: '《种地吧第二季》延续了第一季的真实农耕纪实风格，十个少年继续在田间地头辛勤劳作。没有剧本、没有刻意制造冲突，纯粹记录年轻人在土地上的汗水与收获。节目以慢节奏和真实感打动了无数观众，豆瓣评分高达9.0，是近年来口碑最好的综艺之一。',
  },
  {
    id: 'zongyi-4',
    title: '哈哈哈哈哈第四季',
    category: 'zongyi',
    subcategory: '旅行真人秀',
    year: 2024,
    rating: 7.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20road%20trip%20variety%20show%20poster%20style%20scenic%20highway%20mountains%20fun%20friends%20traveling%20bright%20vibrant%20cinematic%20happy%20atmosphere%20professional%20show%20poster&width=400&height=225&seq=zy-hahaha4-card&orientation=landscape',
    description: '五哈团再次出发，一路自驾穿越中国的山川湖海，在旅途中收获欢笑与感动。',
    director: '王征宇',
    cast: ['邓超', '陈赫', '鹿晗', '范志毅', '董宝石'],
    region: '中国大陆',
    episodes: 12,
    isHot: false,
    isNew: true,
    updateInfo: '更新至第6期',
    content: '《哈哈哈哈哈第四季》继续由邓超、陈赫、鹿晗领衔的五哈团担纲，本季自驾路线更加丰富，从西北大漠到江南水乡，成员们在旅途中不仅要完成各种奇葩任务，还要应对旅途中的种种意外。真实不做作的相处模式和旅途中的自然风光是本节目最大的魅力。',
  },
  {
    id: 'zongyi-5',
    title: '令人心动的offer第五季',
    category: 'zongyi',
    subcategory: '职场观察',
    year: 2024,
    rating: 8.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20workplace%20observation%20show%20poster%20style%20modern%20office%20law%20firm%20professional%20young%20people%20bright%20clean%20cinematic%20corporate%20atmosphere%20professional%20show%20poster&width=400&height=225&seq=zy-offer5-card&orientation=landscape',
    description: '律政职场观察类节目，记录法学实习生们在顶级律所的残酷竞争与成长蜕变。',
    director: '徐晴',
    cast: ['何炅', '撒贝宁', '张纯烨', '刘思远'],
    region: '中国大陆',
    episodes: 10,
    isHot: false,
    isNew: false,
    updateInfo: '已完结',
    content: '《令人心动的offer第五季》回归律政主题，聚焦于一群法学专业实习生在顶级律所的实习生活。节目通过真实的职场案例和高压的工作环境，展现了年轻法律人的专业素养和成长历程。观察室嘉宾的精彩点评为观众提供了多角度的职场洞察。',
  },
  {
    id: 'zongyi-6',
    title: '乘风2024',
    category: 'zongyi',
    subcategory: '舞台竞演',
    year: 2024,
    rating: 7.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20stage%20performance%20show%20poster%20style%20glamorous%20stage%20spotlights%20female%20performers%20dazzling%20costumes%20cinematic%20theatrical%20lighting%20elegant%20professional%20show%20poster&width=400&height=225&seq=zy-chengfeng2024-card&orientation=landscape',
    description: '三十位姐姐再度集结，用舞台证明年龄只是数字，展现成熟女性的魅力与力量。',
    director: '吴梦知',
    cast: ['戚薇', '陈丽君', '刘忻', '郭碧婷', '何洁'],
    region: '中国大陆',
    episodes: 12,
    isHot: true,
    isNew: true,
    updateInfo: '更新至第9期',
    content: '《乘风2024》延续了前几季的成功模式，三十位30+的女性艺人通过舞台竞演展现自己的才华与魅力。本季在舞美设计和赛制上进行了升级，更加注重选手的个人表达和团队协作。姐姐们在舞台上突破自我的精神感染力十足，每一场公演都令人期待。',
  },
];

export const categories = [
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'dianying', name: '电影', icon: 'ri-film-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line' },
];

export const categoryNames: Record<string, string> = {
  dianshiju: '电视剧',
  dianying: '电影',
  zongyi: '综艺',
};